import * as React from 'react';
import { OutlineCheckbox } from 'common/components/core/form/Checkbox';

export default class SelectableItemInner extends React.PureComponent {
    handleChange = (value, event) => {
        if (!this.props.isSelected) {
            this.props.onSelect(this.props, event);
        } else {
            this.props.onUnselect(this.props, event);
        }
    };

    render() {
        const {
            onMouseOut,
            onMouseOver,
            isSelected,
            value,
            theme,
            className
        } = this.props;
        return (
            <li
                className={className}
                onMouseOut={onMouseOut}
                onMouseOver={onMouseOver}
            >
                <OutlineCheckbox
                    checked={isSelected}
                    onChange={this.handleChange}
                    label={value}
                    theme={theme}
                />
            </li>
        );
    }
}
